module.exports = __webpack_public_path__ + "static/img/lte.46bb106.svg";